module.exports = __webpack_public_path__ + "static/media/IMG_7294.1981a488.JPG";